/* eslint-disable */
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import orderConfirmationDoneSelector from '../../State/Store/Orders/Selectors/OrderConfirmationDone.selector';
import orderConfirmationErrorSelector from '../../State/Store/Orders/Selectors/OrderConfirmationError.selector';
import orderConfirmedSelector from '../../State/Store/Orders/Selectors/OrderConfirmed.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import Spinner from '../Spinner/Spinner.component';
import OrderConfirmationMessagePropTypes from './OrderConfirmationMessage.component.props';
import orderConfirmationMessageStyles from './OrderConfirmationMessage.component.styles';

/**
 * OrderConfirmationMessageComponent
 * @export
 * @class OrderConfirmationMessageComponent
 * @extends {React.Component<OrderConfirmationMessageComponentComposedProps, OrderConfirmationMessageComponentState>}
 */
export class OrderConfirmationMessageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConfirmationMessageComponentProps>}
   * @memberof OrderConfirmationMessageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConfirmationMessage`}
   * @memberof OrderConfirmationMessageComponent
   */
  static displayName = `OrderConfirmationMessage`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConfirmationMessageComponent
   */
  static propTypes = OrderConfirmationMessagePropTypes;

  /**
   * Data specific to the `<OrderConfirmationMessageComponent />` instance
   * @type {OrderConfirmationMessageComponentState}
   * @memberof OrderConfirmationMessageComponent
   */
  state = {
    error: null,
    message: null,
    showMessage: false,
  };

  /**
   * componentDidUpdate
   * @param {React.props} prevProps The `props` prior to the update
   * @returns {void} void
   * @memberof OrderConfirmationMessageComponent
   */
  componentDidUpdate(prevProps) {
    const { orderConfirmationDone } = this.props;
    const { showMessage } = this.state;
    if (!showMessage && orderConfirmationDone === true) {
      this.onOpenConfirmMessage();
    }
  }

  /**
   * onCloseConfirmMessage
   * @returns {React.Component} component
   * @memberof OrderConfirmationMessageComponent
   */
  onCloseConfirmMessage = () => {
    this.setState({
      error: null,
      message: null,
      showMessage: false,
    });
  };

  /**
   * onOpenConfirmMessage
   * @returns {React.Component} component
   * @memberof OrderConfirmationMessageComponent
   */
  onOpenConfirmMessage = () => {
    const { i18nSection, orderConfirmationDone, orderConfirmationError, orderConfirmed } = this.props;
    const errorCode = get(orderConfirmationError, `data.errorCode`, `BadResponseFromCommand`);
    const errorMessage = orderConfirmationError && `OrderService.${i18nSection}.ErrorMessages.${errorCode}`;
    const successMessage = orderConfirmed && orderConfirmationDone && `OrderService.${i18nSection}.CompleteMessage`;
    const message = errorMessage || successMessage;
    this.setState({
      error: orderConfirmationError,
      message,
      showMessage: true,
    });
  };

  /**
   * Render Confirmation Message from Snackbar
   * @returns {React.Component} component
   * @memberof OrderConfirmationMessageComponent
   */
  renderConfirmationMessage() {
    const { classes, currentOrder } = this.props;
    const { error, message, showMessage } = this.state;
    const {
      summary: { orderCode, title },
    } = currentOrder;
    const autoHideDuration = error ? null : 5000;
    return (
      <ClickAwayListener onClickAway={this.onCloseConfirmMessage}>
        <Snackbar autoHideDuration={autoHideDuration} onClose={this.onCloseConfirmMessage} open={showMessage}>
          <SnackbarContent
            action={
              error && (
                <Button color="secondary" onClick={this.onCloseConfirmMessage}>
                  OK
                </Button>
              )
            }
            message={
              message && (
                <I18n align="center" className={classes.snackBarMessage} data={{ orderCode, title }}>
                  {message}
                </I18n>
              )
            }
          />
        </Snackbar>
      </ClickAwayListener>
    );
  }

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConfirmationMessageComponent />`
   * @memberof OrderConfirmationMessageComponent
   */
  render() {
    const { currentOrder } = this.props;
    const { summary } = currentOrder || {};
    if (!summary) {
      return;
    }
    const { classes, orderConfirmationDone, orderConfirmed } = this.props;
    const processing = orderConfirmed === null && orderConfirmationDone === false;
    if (processing) {
      return (
        <div className={classes.fullScreenOverlay}>
          <Spinner color="secondary" />
        </div>
      );
    }
    return this.renderConfirmationMessage();
  }
}

/** @type {React.ComponentClass<OrderConfirmationMessageComponentProps>} */
const OrderConfirmationMessage = compose(
  withStyles(themeCreateInjectableStyles(orderConfirmationMessageStyles), { withTheme: true }),
  connect((state) => ({
    orderConfirmationDone: orderConfirmationDoneSelector(state),
    orderConfirmationError: orderConfirmationErrorSelector(state),
    orderConfirmed: orderConfirmedSelector(state),
  })),
)(OrderConfirmationMessageComponent);

export default OrderConfirmationMessage;
